import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "sub",
  "use": "sub-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"sub\"><defs><style></style></defs><path d=\"M512 22C241.38 22 22 241.38 22 512s219.38 490 490 490 490-219.38 490-490S782.62 22 512 22zm290.72 490.09c0 16.57-13.43 30-30 30H251.28c-16.57 0-30-13.43-30-30v-.17c0-16.57 13.43-30 30-30h521.44c16.57 0 30 13.43 30 30v.17z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol